// utils/mapPackageToCartItem.ts

import { PackageModel } from "../../repositories/package.repository";
import { CartItem } from "../../types/common";
export function mapPackageToCartItem(pkg: PackageModel): CartItem {
  return {
    packageId: pkg.packageId,
    price: pkg.price,
    currencies: pkg.currencies,
    data: pkg.data,
    minutes: pkg.minutes,
    packageName: pkg.packageName,
    duration: pkg.duration,
    countries: pkg.countries,
    quantity: 1, // default when adding to cart
  };
}
